module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "expander-label",
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row header-titles-row"
  }, _vm._l((_vm.component.header), function(header, index) {
    return _c('div', {
      key: ("expander_header_" + (_vm.component.name) + "_" + index),
      class: ("col-xs-" + (Math.floor(12 / _vm.component.header.length)))
    }, [_vm._v("\n                " + _vm._s(header.label) + "\n        ")])
  }), 0), _vm._v(" "), _vm._l((_vm.expanderTables), function(table, tableIdx) {
    return _c('div', {
      staticClass: "expander-table"
    }, [_c('div', {
      staticClass: "row header-row"
    }, _vm._l((_vm.component.header), function(header, index) {
      return _c('div', {
        key: ("expander_header_" + (_vm.component.name) + "_" + index),
        class: ("col-xs-" + (Math.floor(12 / _vm.component.header.length)))
      }, [(!index) ? _c('span', {
        class: ("expand-icon " + (_vm.isExpanded(table) ? 'collapse' : '')),
        on: {
          "click": function($event) {
            return _vm.toggleTableVisibility(table)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "header-contents"
      }, [_c('compliance-renderer-block', {
        key: ("expander_header_contents_" + (_vm.component.name) + "_" + index),
        attrs: {
          "component": _vm.removeLabel(header),
          "json_data": _vm.value,
          "instance": table,
          "readonlyForm": _vm.readonly
        }
      })], 1), _vm._v(" "), (tableIdx && index == _vm.component.header.length - 1 && !_vm.readonly) ? _c('a', {
        staticClass: "delete-icon fa fa-trash-o",
        attrs: {
          "title": "Delete row"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeTable(table)
          }
        }
      }) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      class: {
        'hidden': !_vm.isExpanded(table)
      }
    }, _vm._l((_vm.component.expander), function(subcomponent, index) {
      return _c('div', {
        key: ("expander_row_" + (_vm.component.name) + "_" + index),
        staticClass: "row expander-row"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('compliance-renderer-block', {
        key: ("expander_contents_" + (_vm.component.name) + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.value,
          "instance": table,
          "readonlyForm": _vm.readonly
        }
      })], 1)])
    }), 0)])
  }), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "btn btn-primary add-new-button",
    attrs: {
      "type": "button",
      "value": "Add New"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewTable($event)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4417c808"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/compliance_expander_table.vue
// module id = 965
// module chunks = 0